// Ilustración de proporciones: contorno con bordes redondeados y sombra por el soporte trasero.
export const LaminaIllustration = ({ w, h, maxW = 220, maxH = 220, pxPerCm, label, children, testId }) => {
  const scale = pxPerCm || Math.min(maxW / w, maxH / h);
  return (
    <div className="flex items-center justify-center" style={{ height: maxH }} data-testid={testId}>
      <div className="lam relative overflow-hidden bg-gradient-to-br from-[#EAE7E2] via-[#F3EFE8] to-[#D8C8AE] transition-[width,height] duration-500 ease-out"
        style={{ width: w * scale, height: h * scale }}>
        {children}
        {label && <span className="absolute inset-0 grid place-items-center text-[0.7rem] tracking-[0.14em] text-[#080808]/55">{label}</span>}
      </div>
    </div>
  );
};

export const PendingPhoto = ({ label = "Foto real pendiente", className = "", testId }) => (
  <div data-testid={testId} className={`grid min-w-0 place-items-center bg-[#EAE7E2] p-2 text-center text-[0.65rem] uppercase tracking-[0.12em] text-[#080808]/50 ${className}`}>
    {label}
  </div>
);

export const OrientationToggle = ({ value, onChange, testId = "orientation-toggle" }) => (
  <div role="radiogroup" aria-label="Orientación" data-testid={testId} className="inline-flex rounded-full border border-[#080808]/15 p-1">
    {["horizontal", "vertical"].map((o) => (
      <button key={o} role="radio" aria-checked={value === o} data-testid={`${testId}-${o}`} onClick={() => onChange(o)}
        className={`rounded-full px-5 py-2 text-xs font-medium uppercase tracking-[0.12em] transition-colors ${value === o ? "bg-[#080808] text-[#FAF8F4]" : "text-[#080808]/65 hover:text-[#080808]"}`}>
        {o === "horizontal" ? "Horizontal" : "Vertical"}
      </button>
    ))}
  </div>
);
